import React from 'react';
import PropTypes from 'prop-types';

export default class SettingsPanel extends React.Component
{
    render()
    {
        const {title, description, children} = this.props;

        return <div className='flex flex-col bg-white shadow rounded-lg px-4 py-5 sm:p-6 space-y-8'>

            <div>
                <h2 className="text-xl font-medium text-gray-700">
                    {title}
                </h2>
                <p className="mt-1 text-sm text-gray-500">
                    {description}
                </p>
            </div>
            { children }
        </div>
    }
}
